import { ReactComponent as CalendarIcon } from './calendar.svg';
import { ReactComponent as LogoExtended } from './carecircle_icon_master_large.svg';
import { ReactComponent as DefaultAvatar } from './default_avatar.svg';
import { ReactComponent as DropdownIcon } from './dropdown_icon.svg';
import { ReactComponent as InfoIcon } from './info.svg';
import { ReactComponent as Logo } from './logo.svg';
import { ReactComponent as NotificationIcon } from '@libs/core/src/lib/assets/svg/notification.svg';
import { ReactComponent as NewNotificationIcon } from '@libs/core/src/lib/assets/svg/new_notification.svg';
import { ReactComponent as SearchIcon } from './search.svg';
import { ReactComponent as SettingsGearIcon } from './settings_gear.svg';
import { ReactComponent as SignOutIcon } from './sign_out.svg';
import { ReactComponent as ScrollUpIcon } from './scroll_up_icon.svg';
import { ReactComponent as NextBase } from './next_icon.svg';
import { ReactComponent as BackBase } from './back_icon.svg';
import { styled } from '@mui/material/styles';

import { ReactComponent as DeleteIcon } from './delete_icon.svg';
import { ReactComponent as ValidationErrorIcon } from './error_icon.svg';
import { ReactComponent as ExpandIcon } from './expand_icon.svg';
import { ReactComponent as IcareBotIcon } from './icare_bot.svg';
import { ReactComponent as RemoveIcon } from './remove_icon.svg';
import { ReactComponent as SelectedRedIcon } from './selected_icon_red.svg';
import { ReactComponent as SemicircleUpIcon } from './semicircle_up.svg';
import { ReactComponent as SemicircleDownIcon } from './semicircle_down.svg';
import { ReactComponent as ConversationsIcon } from '@libs/core/src/lib/assets/svg/conversation.svg';
import { ReactComponent as SelectedAvatarIcon } from './selected_avatar.svg';
import { ReactComponent as SearchMessagesIcon } from './search_messages.svg';
import { ReactComponent as MostFrequentQuestionsIcon } from './most_freq_questions.svg';
import { ReactComponent as MostFrequentQuestionsActiveIcon } from './most_freq_questions_active.svg';
import { ReactComponent as IcareIcon } from './icare.svg';
import { ReactComponent as RemoveIconWithBackground } from './remove_icon_with_background.svg';
import { ReactComponent as NoPostFoundIcon } from './no_posts_icon.svg';
import { ReactComponent as SmallDropdownIcon } from './small_dropdown_icon.svg';
import { ReactComponent as UploadVideoIcon } from './upload_video_icon.svg';
import { ReactComponent as DeleteVideoIcon } from './delete_video_icon.svg';
import { ReactComponent as VideoTitleClipIcon } from './video_title_clip_icon.svg';
import { ReactComponent as WarningLargeYellowCircle } from './warning_large_yellow_circle.svg';

const NextIcon = styled(NextBase)(({ theme }) => ({
  transform: theme.direction === 'rtl' ? 'scaleX(-1)' : undefined,
}));
const BackIcon = styled(BackBase)(({ theme }) => ({
  transform: theme.direction === 'rtl' ? 'scaleX(-1)' : undefined,
}));

export {
  DefaultAvatar,
  LogoExtended,
  Logo,
  SearchIcon,
  NotificationIcon,
  SettingsGearIcon,
  InfoIcon,
  SignOutIcon,
  CalendarIcon,
  DropdownIcon,
  ScrollUpIcon,
  ValidationErrorIcon,
  DeleteIcon,
  ExpandIcon,
  SelectedRedIcon,
  NextIcon,
  BackIcon,
  IcareBotIcon,
  RemoveIcon,
  SemicircleUpIcon,
  SemicircleDownIcon,
  ConversationsIcon,
  SelectedAvatarIcon,
  SearchMessagesIcon,
  MostFrequentQuestionsIcon,
  MostFrequentQuestionsActiveIcon,
  IcareIcon,
  RemoveIconWithBackground,
  NoPostFoundIcon,
  SmallDropdownIcon,
  UploadVideoIcon,
  DeleteVideoIcon,
  VideoTitleClipIcon,
  WarningLargeYellowCircle,
  NewNotificationIcon,
};
